import Backbone from "backbone";

let initialized = false;
let container = null;
let message = null;
let retryButton = null;

function hide() {
  container?.setAttribute("hidden", "");
}

function show(text, { retry = false } = {}) {
  if (!container || !message) return;
  message.textContent = text;
  retryButton?.classList.toggle("d-none", !retry);
  container.removeAttribute("hidden");
}

function handleDegraded() {
  show("Live updates disconnected — reconnecting.");
}

function handleSyncing() {
  if (container && !container.hasAttribute("hidden")) {
    show("Live connection restored — syncing changes.");
  }
}

function handleSyncFailed() {
  show("Live updates could not be fully restored.", { retry: true });
}

const LiveQueryBanner = {
  init() {
    if (initialized) return;

    container = document.getElementById("liveQueryStatus");
    message = document.getElementById("liveQueryStatusMessage");
    retryButton = document.getElementById("liveQueryRetry");
    if (!container || !message) return;

    initialized = true;
    Backbone.on("livequery:degraded", handleDegraded);
    Backbone.on("livequery:syncing", handleSyncing);
    Backbone.on("livequery:sync-failed", handleSyncFailed);
    Backbone.on("livequery:restored livequery:shutdown", hide);

    retryButton?.addEventListener("click", () => {
      show("Retrying live update sync.");
      Backbone.trigger("livequery:retry");
    });
    document
      .getElementById("liveQueryRefresh")
      ?.addEventListener("click", () => window.location.reload());
    document
      .getElementById("liveQueryDismiss")
      ?.addEventListener("click", hide);
  },
};

export default LiveQueryBanner;
